import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm border border-accent-200">
            从 0# 走向千县万村
          </div>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            一个样板，不是终点，而是一套可以复制的模型
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            帝星 0# 完成城市端验证，大庄科 1# 承接乡村复制，标准化产品矩阵驱动县域规模化扩张。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/scale"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              了解千县万村
            </Link>
            <Link
              to="/products"
              className="px-8 py-3 rounded-md border border-primary-400 text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              查看产品矩阵
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}